import React, { useState, useRef, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Tabs from '../../../../../Components/Tabs';
import ClientBulkUpdateListScreen from './ClientBulkUpdateListScreen';
import NatureCallTypeListScreen from './NatureCallTypeListScreen';
import UploadClientsListFileScreen from './UploadClientsListFileScreen';
import OtherSettingsConteoller from '../../../../Controllers/AdminScreens/Services/Settings/OtherSettingsController';


const OtherSettingsScreen = () => {
    const{
        loading,
    error,
    callsList,
    fetchNatureOfCallsList,
    importMasterList,
    importMasterListError,
    importMasterListLoading,
    fetchImportMasterList
    } = OtherSettingsConteoller()

    const { state } = useLocation();
    const [selectedTab, setSelectedTab] = useState(state?.selectedTab || 0);
    const [disabledTabs, setDisabledTabs] = useState([]);

    useEffect(() => {
        const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_') || '{}');
        const { per_name_sub_json } = storedUserInfo?.user_permissions?.services_sett || {};

        const tabPermissions = [
            { name: "Bulk Update Client Information", key: "others_bulk_update_client_info"},
            { name: "Manage Nature of Calls", key: "others_manage_nature_of_calls"},
            { name: "Import Master", key: "others_import_master"}
        ]

        const disabledTabIndices = tabPermissions
              .map((tab, index) => (per_name_sub_json[tab?.key] !== 1 ? index : null))
              .filter(index => index !== null);

        setDisabledTabs(disabledTabIndices);
        if (disabledTabIndices.includes(selectedTab)) {
            // setSelectedTab(0);
            const firstEnabledTab = tabPermissions.findIndex((_, index) => !disabledTabIndices.includes(index));
            setSelectedTab(firstEnabledTab !== -1 ? firstEnabledTab : 0)
        }
    }, [selectedTab]);

    const handleTabChange = (index) => {
        if (disabledTabs.includes(index)) return;
        setSelectedTab(index);
    };

    return (
        <div style={styles.mainContent}>
            <div className='title-container' style={{ paddingBottom: 10 }}>
                <h2 className='title'>Other Settings</h2>
            </div>

            <div>
                <Tabs tabs={['Bulk Update Client Information', 'Manage Nature of Calls', 'Import Master']}
                selectedIndex={selectedTab}
                onTabChange={handleTabChange}
                disabledTabs={disabledTabs}
                >
                    {selectedTab === 0 && !disabledTabs.includes(0) &&<ClientBulkUpdateListScreen />}
                    {selectedTab === 1 && !disabledTabs.includes(1) && <NatureCallTypeListScreen  loading={loading} error={error} callsList={callsList} onRefresh={fetchNatureOfCallsList}/>}
                    {selectedTab === 2 && !disabledTabs.includes(2) && <UploadClientsListFileScreen importMasterListLoading={importMasterListLoading} importMasterList={importMasterList} importMasterListError={importMasterListError} onRefresh={fetchImportMasterList} />}
                </Tabs>
            </div>

        </div>


    )

};

const styles = {
    mainContent: {
        width: '95%',
        margin: 'auto'
    }

}

export default OtherSettingsScreen;